<template>
  <b-container>
    <summary-dispatch
      :brick_id="brick_id"
      :project_id="project_id"
      :metavariables_dicts_poids="metavariables_dicts_poids"
    />

    <communicating-tables-lists
      :brick_id="brick_id"
      :rhs_title="$t('dispatch_chosen_tables')"
      :all_tables="tables_undeleted"
      :rhs_elements="tables_info"
      :element_constructor="rhs_table_structure"
      :disabled="changes_disabled"
      @input="maj($event)"
    >
      <template v-slot:rhs_table_component="slot_props">
        <b-list-group-item>
          <div class="table-handle hand-pointer">
            <span class="fas fa-grip-vertical fa-fw" />
            {{ slot_props.element_name }}
          </div>
          <hr class="chosen_table_separator" />

          <b-form-group :disabled="slot_props.disabled">
            <label>
              <b> {{ $t('chosen_mode') }}</b>
            </label>
            <b-form-radio-group
              v-model="slot_props.element.metavariables_expressions"
            >
              <b-form-radio value="is_training == True">
                {{ $t('train') }}
              </b-form-radio>
              <b-form-radio value="is_training == False">
                {{ $t('eval') }}
              </b-form-radio>
            </b-form-radio-group>
            <b-form-group>
              <label>
                <b> {{ $t('manual') }} :</b>
              </label>
              <b-form-input
                v-model="slot_props.element.metavariables_expressions"
              />
              <div class="mt-2">
                <b>{{ $t('selected_for_metavariables_dicts') }} :</b>
              </div>
              <div>
                {{ matching_metavariables_dicts[slot_props.element.uid] }}
              </div>
            </b-form-group>
          </b-form-group>
        </b-list-group-item>
      </template>
    </communicating-tables-lists>
  </b-container>
</template>

<i18n>
{
  "en": {
    "dispatch_chosen_tables": "Liste of tables chosen for dispatch",
    "chosen_mode": "Chosen mode :",
    "one_table_is_not_parametrized": "At least one table has no chosen mode",
    "selected_for_metavariables_dicts": "Selected for metavariables dicts"
  },
  "fr": {
    "dispatch_chosen_tables": "Liste des tables choisies pour le dispatch",
    "chosen_mode": "Mode choisi :",
    "one_table_is_not_parametrized": "Une des tables n'a pas de mode choisi",
    "selected_for_metavariables_dicts": "Sélectionnée pour les dictionnaires de métavariables"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { is_dispatch_parametrized } from '@/utils.js'
import { DispatchTableInfoEntity } from '@/components/object_model.js'

import { global_brick_mixin } from '@/components/mixin.js'
import CommunicatingTablesLists from '@/components/communicating_tables_lists.vue'
import SummaryDispatch from './summary_dispatch.vue'

// *****************************************************************************

export default {
  name: 'BrickDispatchTable',
  components: {
    CommunicatingTablesLists,
    SummaryDispatch,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      rhs_table_structure: DispatchTableInfoEntity,
      tables_info: [],
    }
  },
  computed: {
    parents_tables_uids() {
      let res = _.map(
        this.tracking_infos,
        elt => (elt || {}).parent_table_uid || -1
      )

      return res
    },
    // matching_metavariables_dicts() {
    //   let res = _.map(this.tables_info, table => _.map(_.filter(this.parents_tables_uids, uid === table.uid), dict_poid => this.available_metavariables_dicts(dict_poid)))
    //   return res
    // },
    // matching_metavariables_dicts() {
    //   let res = {}

    //   _.forEach(
    //     this.tables_info,
    //     table =>
    //       (res[table.uid] = _.map(
    //         _.filter(this.parents_tables_uids, uid => {
    //           return uid === table.uid
    //         }),
    //         dict_poid => dict_poid
    //       ))
    //   )

    //   console.log('Matching metavariables dicts', res)

    //   return res
    // },

    matching_metavariables_dicts() {
      let res = {}

      _.forEach(this.tables_info, table => {
        let entry = []
        _.forEach(this.parents_tables_uids, (uid, index) => {
          if (uid === table.uid) {
            entry.push(
              this.available_metavariables_dicts[
                this.metavariables_dicts_poids[index]
              ]
            )
          }
        })
        res[table.uid] = entry
      })

      return res
    },
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        // N.B PL : Do we let the ancient name in the frontend at some places
        // or do we change everywhere ?
        parents_info: this.tables_info,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        let cur_tables_info = this.cur_brick.parents_info
        if (!_.isEqual(cur_tables_info, this.tables_info)) {
          this.tables_info = _.cloneDeep(cur_tables_info)
        }
      },
    },
  },
  methods: {
    maj(event) {
      this.tables_info = _.cloneDeep(event)
    },
  },
}
</script>
